import { initMixin } from './init';
import { vueMixin } from './initVue';
import { servicesMixin } from './initServices';
import { httpMixin } from './initHttp';
import { startMixin } from './start';

/**
 * Define a generic application container that will be extended.
 * @param options
 * @constructor
 */
export function Hammer (options) {
  this._init(options);
}

initMixin(Hammer);
startMixin(Hammer);
vueMixin(Hammer);
servicesMixin(Hammer);
httpMixin(Hammer);
